import React from "react";
import { Link } from "react-router-dom";

// This is the component for a single article detail page
const SecondBlog = () => {
  // This would typically be fetched based on URL params in a real app
  const article = {
    id: 1,
    title: "When is Laylatul Qadr in 2025?",
    subtitle: "Finding the Night of Power this Ramadan",
    category: "SPIRITUAL GUIDANCE",
    publishDate: "April 12, 2025",
    author: {
      name: "Imam Ahmad Saeed",
      title: "Islamic Scholar",
      image: "https://randomuser.me/api/portraits/men/75.jpg",
    },
    featuredImage:
      "https://images.theconversation.com/files/455174/original/file-20220330-6091-i4h5l2.jpg?ixlib=rb-4.1.0&q=20&auto=format&w=320&fit=clip&dpr=2&usm=12&cs=strip",
    readTime: "5 min read",
    content: `
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">The Significance of Laylatul Qadr</h2>
      <p>We're already halfway through Ramadan, and we're about to enter the most holy night in Islam. The last ten nights of Ramadan are especially sacred, particularly the odd-numbered nights, as this is when Laylatul Qadr (The Night of Power) is believed to occur.</p>
      
      <p>Allah says in the Quran: "The Night of Decree is better than a thousand months" (97:3). This means that worship during this single night is better than worship conducted over a thousand months—more than 83 years of worship!</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">When is Laylatul Qadr in 2025?</h2>
      <p>Based on astronomical calculations, Ramadan 2025 is expected to begin around March 1, 2025, and will likely end around March 30, 2025. This means the last ten nights will begin approximately on March 20.</p>
      
      <p>While the exact date of Laylatul Qadr is not specified, it is commonly believed to fall on one of the odd-numbered nights of the last ten days of Ramadan. These would be the 21st, 23rd, 25th, 27th, or 29th nights of Ramadan.</p>
      
      <p>The 27th night (likely falling on March 27, 2025) is most widely regarded as Laylatul Qadr, though we are encouraged to seek it throughout all the last ten nights.</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">Signs of Laylatul Qadr</h2>
      <p>The Prophet Muhammad (peace be upon him) described several signs by which Laylatul Qadr might be recognized:</p>
      
      <ul>
        <li>The night is peaceful and tranquil</li>
        <li>The weather is mild and neither hot nor cold</li>
        <li>The moon shines clear and bright</li>
        <li>No meteors are shot at the devils on that night</li>
        <li>The night is neither very cold nor very hot</li>
        <li>Rain may fall either during the night or during the following day</li>
        <li>The sun rises in the morning without strong rays</li>
      </ul>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">Recommended Acts of Worship</h2>
      <p>To maximize the blessings of these sacred nights, consider incorporating these acts of worship:</p>
      
      <ul>
        <li>Perform extra prayers (Tahajjud or Qiyam al-Layl)</li>
        <li>Recite the Quran</li>
        <li>Make abundant dua (supplication)</li>
        <li>Engage in dhikr (remembrance of Allah)</li>
        <li>Give in charity</li>
        <li>Seek forgiveness</li>
      </ul>
      
      <p>Aisha (may Allah be pleased with her) once asked the Prophet (peace be upon him) what she should pray for if she found Laylatul Qadr. He advised her to say: "Allahumma innaka 'afuwwun tuhibbul 'afwa fa'fu 'anni" (O Allah, You are forgiving and love forgiveness, so forgive me).</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">Preparing for the Last Ten Nights</h2>
      <p>Many Muslims choose to practice I'tikaf (spiritual retreat in the mosque) during the last ten days of Ramadan. This involves staying in the mosque, dedicating oneself completely to worship and minimizing worldly distractions.</p>
      
      <p>If a full I'tikaf is not possible, try to arrange your schedule to maximize your time for worship during these nights. Reduce your obligations, prepare meals in advance, and try to rest during the day so you can stay awake for longer periods during the night.</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">Community Events</h2>
      <p>Many mosques hold special programs during the last ten nights of Ramadan. These often include:</p>
      
      <ul>
        <li>Extended Taraweeh prayers</li>
        <li>All-night worship gatherings</li>
        <li>Quranic recitation sessions</li>
        <li>Islamic lectures and discussions</li>
        <li>Community iftars (breaking of the fast)</li>
      </ul>
      
      <p>Check with your local masjid for their schedule of events during these blessed nights.</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">Final Thoughts</h2>
      <p>The last ten nights of Ramadan represent an incredible opportunity for spiritual growth and connection with Allah. By seeking Laylatul Qadr throughout these nights and increasing our worship, we can hope to receive blessings equivalent to more than 83 years of worship.</p>
      
      <p>May Allah allow us all to witness Laylatul Qadr and accept our worship during this blessed month. Ameen.</p>
    `,
    tags: [
      "Laylatul Qadr",
      "Night of Power",
      "Ramadan 2025",
      "Islamic Worship",
      "Last Ten Nights",
    ],
    relatedPosts: [
      {
        id: 2,
        title: "RAMADAN WITH PALESTINIANS",
        image:
          "https://images.unsplash.com/photo-1540866225557-9e4c58100c67?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1516&q=80",
        category: "COMMUNITY",
      },
      {
        id: 3,
        title:
          "The Rise of 'Judgement' During Ramadan: Unpacking 'Ramadan Muslims'",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS3oBlct21G6_iyHETI0VG33H9sCbbGhUge5Q&s",
        category: "REFLECTIONS",
      },
      {
        id: 4,
        title: "3,000 Muslims Took Over Times Square for Taraweeh",
        image:
          "https://images.unsplash.com/photo-1522083165195-3424ed129620?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1160&q=80",
        category: "COMMUNITY",
      },
    ],
  };

  return (
    <div className="font-sans max-w-4xl mx-auto p-4 pb-16">
      {/* Breadcrumb Navigation */}
      <div className="flex items-center text-sm text-gray-500 mb-6">
        <Link to="/" className="hover:text-pink-500">
          Home
        </Link>
        <span className="mx-2">/</span>
        <Link to="/blogs" className="hover:text-pink-500">
          Blogs
        </Link>
        <span className="mx-2">/</span>
        <span className="text-gray-700">
          {article.title.substring(0, 30)}...
        </span>
      </div>

      {/* Category Tag */}
      <div className="mb-4 text-pink-500 font-bold">{article.category}</div>

      {/* Article Title */}
      <h1 className="text-4xl font-serif font-bold mb-2">{article.title}</h1>
      <h2 className="text-2xl font-serif text-gray-600 mb-6">
        {article.subtitle}
      </h2>

      {/* Article Meta */}
      <div className="flex items-center justify-between mb-8 border-b border-gray-200 pb-4">
        <div className="flex items-center">
          <img
            src={article.author.image}
            alt={article.author.name}
            className="w-12 h-12 rounded-full mr-4 hover:scale-105 transition-transform duration-300"
          />
          <div>
            <div className="font-medium">{article.author.name}</div>
            <div className="text-sm text-gray-500">{article.author.title}</div>
          </div>
        </div>
        <div className="text-sm text-gray-500">
          <span>{article.publishDate}</span>
          <span className="mx-2">•</span>
          <span>{article.readTime}</span>
        </div>
      </div>

      {/* Featured Image with Label */}
      <div className="mb-8 relative">
        <img
          src={article.featuredImage}
          alt={article.title}
          className="w-full h-auto rounded-lg shadow-md hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-4 right-4 bg-pink-500 text-white p-3 text-sm font-bold">
          <div>Ramadan</div>
          <div>2025</div>
        </div>
      </div>

      {/* Article Content */}
      <div
        className="prose prose-lg max-w-none mb-12"
        dangerouslySetInnerHTML={{ __html: article.content }}
      />

      {/* Tags */}
      <div className="mb-12">
        <h3 className="text-lg font-serif font-bold mb-4 text-pink-500">
          Related Topics
        </h3>
        <div className="flex flex-wrap gap-2">
          {article.tags.map((tag, index) => (
            <span
              key={index}
              className="bg-gray-100 cursor-default hover:bg-gray-200 text-gray-400 px-3 py-1 rounded-full text-sm"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* Author Box */}
      <div className="bg-gray-50 p-6 rounded-lg shadow-sm mb-12">
        <div className="flex items-start">
          <img
            src={article.author.image}
            alt={article.author.name}
            className="w-16 h-16 rounded-full mr-6 hover:scale-105 transition-transform duration-300"
          />
          <div>
            <h3 className="font-bold text-lg font-serif mb-2">
              About {article.author.name}
            </h3>
            <p className="text-gray-700 mb-4">
              Imam Ahmad Saeed is a respected Islamic scholar specializing in
              Fiqh and Quranic studies. With over 15 years of experience serving
              various communities, he focuses on making Islamic knowledge
              accessible and relevant to Muslims living in the West. He
              currently serves as the resident scholar at the Islamic Center and
              regularly contributes to discussions on contemporary Islamic
              issues.
            </p>
            <div className="flex gap-4">
              <span
                // to="/authors/ahmad-saeed"
                className="text-pink-500 hover:text-pink-500 cursor-default"
              >
                More articles by this author
              </span>
              <span className="text-pink-500 cursor-default hover:text-pink-500">
                Follow on Twitter
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Related Posts */}
      <div>
        <h3 className="text-2xl font-serif font-bold mb-6 cursor-default text-pink-500">
          Related Articles
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {article.relatedPosts.map((post) => (
            <span
              key={post.id}
              className="border-b-4 border-red-600 rounded-bl-md rounded-br-md"
            >
              <div className="mb-3">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-48 object-cover rounded-lg hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="mb-1 text-pink-500 font-bold text-sm cursor-default">
                {post.category}
              </div>
              <h4 className="text-lg font-serif font-bold hover:text-[#730000] cursor-default">
                {post.title}
              </h4>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

// This is the component displaying the card grid that links to article details
const RamadanArticleCards = () => {
  const articles = [
    {
      id: 1,
      title: "When is Laylatul Qadr in 2025?",
      excerpt:
        "We're already halfway through Ramadan, and we're about to enter the most holiest night in Islam. The last ten nights of Ramadan are extra special, especially the odd ones...",
      image:
        "https://images.unsplash.com/photo-1508030731164-041fc0f7cd3f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
      badge: {
        top: "Most",
        bottom: "Popular",
      },
      bottomLabel: "Finding the Night of Power",
    },
    {
      id: 2,
      title: "RAMADAN WITH PALESTINIANS",
      excerpt:
        "Solidarity and spiritual connection: how Muslims around the world are observing Ramadan while supporting Palestinian brothers and sisters.",
      image:
        "https://images.unsplash.com/photo-1540866225557-9e4c58100c67?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1516&q=80",
    },
    {
      id: 3,
      title: "3,000 Muslims Took Over Times Square for Taraweeh",
      excerpt:
        "Thousands gathered under the bright lights of NYC Times Square for a historic Taraweeh prayer. From viral billboards to a surprise spiritual twist...",
      image:
        "https://images.unsplash.com/photo-1522083165195-3424ed129620?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1160&q=80",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {articles.map((article) => (
        <Link
          key={article.id}
          to={`/articles/${article.id}`}
          className="relative block hover:opacity-95 transition-opacity"
        >
          <div className="relative">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-48 object-cover"
            />
            {article.badge && (
              <div className="absolute top-0 right-0 bg-emerald-500 text-white p-2 text-sm">
                <div>{article.badge.top}</div>
                <div>{article.badge.bottom}</div>
              </div>
            )}
            {article.bottomLabel && (
              <div className="absolute bottom-8 left-0 bg-white bg-opacity-75 p-1">
                <p className="text-sm font-bold">{article.bottomLabel}</p>
              </div>
            )}
            <h3 className="font-serif font-bold mt-3">{article.title}</h3>
            <p className="text-xs mt-1">{article.excerpt}</p>
          </div>
        </Link>
      ))}
    </div>
  );
};

export { SecondBlog, RamadanArticleCards };
